module.exports = __webpack_public_path__ + "img/img_side_heartspangle.300cf22b.png";